export const useCompositionEvent = () => {
    const handleCompositionStart = (event: React.CompositionEvent<HTMLDivElement>) => {
        const target = event.target as any;
        target.composing = true;
    };

    const handleCompositionEnd = (event: React.CompositionEvent<HTMLDivElement>) => {
        const target = event.target as any;
        target.composing = false;
    };

    return {
        handleCompositionStart,
        handleCompositionEnd,
    };
};
